





















































import { Component, Vue } from "vue-property-decorator";

@Component
export default class FormExpired extends Vue {
  get fromReview(): boolean {
    return this.$route.query.source === "review";
  }
}
